export default __webpack_public_path__ + "static/media/contmd.82d5a378.jpg";